import { redirect } from "react-router-dom";
import { RootState } from "../../store/store";
import { store } from "../../store/store";
import { verifyUserTokens } from "../../models/authSlice";
import { ROUTES } from "../../utils/constants";

export const authLoader = async () => {
  await store.dispatch(verifyUserTokens());
  const state: RootState = store.getState();

  if (!state.auth.isAuthenticated) {
    return redirect(ROUTES.LOGIN);
  }
  return null;
};
